import React from 'react';
import Login from './components/LoginPage/Login';
import 'antd/dist/antd.css';
const App = () => (React.createElement("div", { className: "App" },
    React.createElement(Login, null)));
export default App;
